import { useCallback, useRef, useState } from "react";
import Modal from "react-modal";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Input from "../Inputs/InputRef";
import { Form } from "@unform/web";
import { FormHandles } from "@unform/core";
import * as Yup from "yup";
import api from "../../services/api";
import { ModalContainer, Title } from "./styles";

type Props = {
  open: boolean;
  onClose: () => void;
};
type Results = boolean | null;

export function PesquisaUc({ open, onClose }: Props) {
  const [search, setSearch] = useState<Results>(null);
  const [disabled, setDisabled] = useState<boolean>(false);
  const formRef = useRef<FormHandles>(null);

  const handleNumericChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentValue = e.target.value.replace(/\D/g, "");
    e.target.value = currentValue;
  };

  const handleClose = () => {
    setSearch(null);
    onClose();
  };

  const handleSubmit = useCallback(async (data) => {
    try {
      setSearch(null);
      formRef.current?.setErrors({});
      setDisabled(true);
      const schema = Yup.object().shape({
        uc: Yup.string().required("Defina uma UC"),
      });
      await schema.validate(data, { abortEarly: false });
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
      const response = await api.get(
        `/csp/representante/pipefy/card/uc/existe?uc=${data.uc}`
      );
      if (response.status === 200) setSearch(response.data.existe === 1);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        formRef?.current?.setFieldError("uc", error.message);
      }
    }
    setDisabled(false);
  }, []);

  return (
    <Modal
      isOpen={open}
      onRequestClose={handleClose}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: "modal-search-uc",
        afterOpen: "modal-base_after-open",
        beforeClose: "modal-base_before-close",
      }}
      overlayClassName={{
        base: "overlay-base",
        afterOpen: "overlay-base_after-open",
        beforeClose: "overlay-base_before-close",
      }}
      shouldCloseOnOverlayClick={true}
    >
      <Form ref={formRef} onSubmit={handleSubmit}>
        <ModalContainer>
          <Title>Consulta unidade consumidora</Title>
          <Button
            className="close-button"
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8, color: "black" }}
          >
            <CloseIcon />
          </Button>
          <Input name="uc" maxLength={15} onChange={handleNumericChange} />
          <Button
            disabled={disabled}
            type="submit"
            sx={{
              backgroundColor: "#6C5AF4",
              "&:hover": {
                backgroundColor: "#6C5AF4",
              },
            }}
            color="primary"
            variant="contained"
          >
            Verificar
          </Button>
          {search !== null && (
            <span
              className="result"
              style={{ color: search ? "#8F0921" : "#3D873D" }}
            >
              {search
                ? "UC não elegível para novas propostas"
                : "UC elegível para novas propostas"}
            </span>
          )}
        </ModalContainer>
      </Form>
    </Modal>
  );
}
